module.exports = __webpack_public_path__ + "static/media/csv.18e854e2.svg";